import React from 'react';
import ToolbarRichSelect, { MEAL_FILTER_OPTIONS } from './ToolbarRichSelect';
import OrderStatusFilterDropdown from './OrderStatusFilterDropdown';
import SchoolFilterDropdown from './SchoolFilterDropdown';

export default function JreatsOrderFilters({
    mealFilter,
    onMealFilterChange,
    schoolOptions,
    schoolSelections,
    onToggleSchool,
    statusOptions,
    statusSelections,
    onToggleStatus,
    onSetAllStatuses,
    showStatusSelectAll = false,
}) {
    return (
        <div className="jreats-order-filters" aria-label="Junior Eats order filters">
            <ToolbarRichSelect
                panelId="jreats-meal-filter"
                value={mealFilter || ''}
                onChange={onMealFilterChange}
                options={MEAL_FILTER_OPTIONS}
                ariaLabel="Select meal type"
                panelTitle="Meal type"
                narrow
            />

            <SchoolFilterDropdown
                panelId="jreats-school-filter"
                schoolOptions={schoolOptions}
                schoolSelections={schoolSelections}
                onToggleSchool={onToggleSchool}
            />

            <OrderStatusFilterDropdown
                panelId="jreats-status-filter"
                statusOptions={statusOptions}
                statusSelections={statusSelections}
                onToggleStatus={onToggleStatus}
                onSetAllStatuses={onSetAllStatuses}
                showSelectAll={showStatusSelectAll}
            />
        </div>
    );
}
